import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <h3 className="footer-logo">AiStonks</h3>
          <p className="footer-tagline">Professional investing. Simplified.</p>
        </div>

        <div className="footer-links">
          <div className="footer-section">
            <h4 className="footer-heading">Product</h4>
            <a href="#how-it-works" className="footer-link">How It Works</a>
            <a href="#why-aistonks" className="footer-link">Why AiStonks</a>
            <a href="#trust" className="footer-link">Trust & Safety</a>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <a href="mailto:founder@aistonks.in" className="footer-link">founder@aistonks.in</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © 2024 AiStonks. All rights reserved.
        </p>
        <p className="footer-disclaimer">
          We do not provide any financial advice.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
